var React = require('react');

function PlayDark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"play-dark-back","cx":"22.5","cy":"22.5","r":"22.5","fill":"rgba(148,148,148,0.26)","key":0}),React.createElement("g",{"transform":"translate(6 6)","key":1},[React.createElement("circle",{"cx":"16.5","cy":"16.5","r":"16.5","fill":"#fff","key":0}),React.createElement("path",{"d":"M5.106,1.789a1,1,0,0,1,1.789,0l4.382,8.764A1,1,0,0,1,10.382,12H1.618a1,1,0,0,1-.894-1.447Z","transform":"translate(25 11) rotate(90)","fill":"#505456","key":1})])]);
}

PlayDark.defaultProps = {"className":"icon-svg","viewBox":"0 0 45 45"};

module.exports = PlayDark;

PlayDark.default = PlayDark;
